/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import PriorityBadge from '../PriorityBadge'
import Ref from '../Ref'
import InterventionStatusBadge from './InterventionStatusBadge'
import { Box, Table, Text } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import EstateInfoHoverCard from '../estate/EstateInfoHoverCard'
import { getEstateLink } from '../../lib/links/estateLinks'
import { getCustomerName } from '../../lib/customer.mjs'

export type InterventionListItemProps = {
  item: Intervention,
  itemLink: string
}

function InterventionListItem (props: InterventionListItemProps) {
  const { item, itemLink } = props
  const intl = useIntl()
  const link = useMemo(() => (
    itemLink.replace(/{id}/g, String(item.id))
  ), [item.id, itemLink])

  const owner = item.Lease?.Lessor ?? item.Estate?.Owner
  const tenant = item.Lease?.Tenant

  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <InterventionStatusBadge intervention={item} />
      </Table.Td>
      <Table.Td>
        <AnchorLink to={link}>
          <FormattedDate value={item.requestedAt} />
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <PriorityBadge priority={item.priority} />
      </Table.Td>
      <Table.Td>
        <AnchorLink to={link}>
          <span title={item.description}>
            {item.subject}
          </span>
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <Ref me="sm" value={item.Estate.reference} />
        <EstateInfoHoverCard estateId={item.estateId}>
          <span>
            <AnchorLink to={getEstateLink(item.estateId)}>
              {item.Estate.title}
            </AnchorLink>
          </span>
        </EstateInfoHoverCard>

        <Box fz="xs">
          {owner != null
            ? <Text inherit c="gray">
              <FormattedMessage id="owner" />
              &nbsp;: {getCustomerName(owner)}
            </Text>
            : null}

          {tenant != null
            ? <Text inherit c="gray">
              <FormattedMessage id="tenant" />
              &nbsp;: {getCustomerName(tenant)}
            </Text>
            : null}
        </Box>
      </Table.Td>
      <Table.Td>
        {item.startDate ? intl.formatDate(item.startDate) : null}
      </Table.Td>
      <Table.Td>
        {item.endDate ? intl.formatDate(item.endDate) : null}
      </Table.Td>
      <Table.Td>
        {item.assignee}
      </Table.Td>
    </SelectableRow>
  )
}

export default InterventionListItem
